import { Node, NodeProps } from "@xyflow/react"
import { cn } from "design-system/utils"
import { useWorkflowEnabled } from "../hooks/useWorkflowEnabled"

export function WorkflowGroupNode({ data }: NodeProps<Node>) {
  const { workflowId = "" } = data as { workflowId?: string }
  const isEnabled = useWorkflowEnabled(workflowId)

  return (
    <div
      className={cn(
        "pointer-events-none h-full w-full rounded-xl border-2 border-dashed transition-colors",
        isEnabled
          ? "border-chart-primary/40 bg-chart-primary/5"
          : "border-muted-foreground/30 bg-muted/40",
      )}
    />
  )
}
